import React, {Fragment, useState} from 'react';
import cx from 'classnames';
import { Button, CardTitle } from 'reactstrap';
import Common from '../../../Common/Common';
import requestApi from "../../../services/requestApi.service";
import { confirmBoxWithImage } from '../../../Common/Appcommon';
class PartnerPopUp extends React.Component{
    constructor(props) {
        super(props);
        this.state = {
            partnercode:''
        }
    }
    handleChange = (e) => {
        this.setState({
            partnercode: e.target.value
        });
    }


    getPartnerPopupContent = () => {
        <div className={`input-variation`}>
            <input
             required={true}
             value={this.state.partnercode}
             onChange={(e) => {this.handleChange(e)}}
             name={'partnercode'}
             type={'text'}
             className={cx('form-control mt-1 mb-2')}
             autoComplete={'off'}
             placeholder={'Enter a valid partner code'}
             /*maxLength={20}*/
             />
        </div>
    }
    
    submitForm = async (e) => {
        e.preventDefault();
        let params = {
            "ENTITY": "WHATSAPPPROCESS",
            "OPERATION": "GET_SPECIFIC_PARTNER_VIEW",
            "PARTNERCODE" : this.state.partnercode,
        };
        let response = await requestApi.processServerRequest(params);
        if(response.issuccess){
            let data = response.data;
            if(data != ""){
                window.location.href = data;
            }else{
                await confirmBoxWithImage("Invalid Partner Code","Please enter a valid partner code.",'',"OK","Cancel","","",false,false,false);
            }
        }
    }   
    render() {
        let serverUrl = process.env.REACT_APP_SERVER_URL;
        let image = serverUrl+"/Content/images/Partner.png";
     return(
        <Common pageTitle={"Partner"}  mainContent={
            <Fragment>
                <div className={"partnerdiv"}>
                    <div className="card-shadow-primary border mb-3 widget-chart widget-chart2 partnercode">
                        <img src={image} className={"custom-width-1 filter-active"} />
                        <CardTitle>{'Partner'}</CardTitle>
                        <input
                                required={true}
                                value={this.state.partnercode}
                                onChange={(e) => {this.handleChange(e)}}
                                name={'partnercode'}
                                type={'text'}
                                className={cx('form-control mt-1 mb-2')}
                                autoComplete={'off'}
                                placeholder={'Enter Partner code'}
                                maxLength={20}
                            />
                        <Button onClick={(e) => {return this.submitForm(e)}} className={`le-button lePrimaryBtn br-4 partnerbtn`} color="primary" type={'submit'}>
                            {'Continue'}
                        </Button>
                    </div>
                </div>
            </Fragment>
        }/>
    )
  }
}

export default PartnerPopUp;